import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { AuthContext } from "../../context/AuthContext";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { Box, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import PulseLoader from "react-spinners/PulseLoader";
import axios from "axios";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getDataWithToken } from "../../services/GetDataService";

import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import EmailIcon from "@mui/icons-material/Email";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { designationList, roleList } from "../../data";
import { handlePostData } from "../../services/PostDataService";
import { handlePutData } from "../../services/PutDataService";
import ImageUpload from "../../utils/ImageUpload";
import MetaTagAndDescription from "../../components/MetaTagAndDescription";

const UpdateModel = ({}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [parent_id, setParent_id] = useState("");
  const [status, setStatus] = useState("");
  const [deviceList, setDeviceList] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [orderNo, setOrderNo] = useState();
  const [file, setFile] = useState(null);
  const [image_alt_text, setImage_alt_text] = useState("");
  const dropzoneRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const [endpoint, setEndpoint] = useState("");
  const [allData, setAllData] = useState({});

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [pageDescription, setPageDescription] = useState("");
  const [pageTitle, setPageTitle] = useState("");
  const [pageTitleDescription, setPageTitleDescription] = useState("");
  const [allserviceMetaTitle, setAllserviceMetaTitle] = useState("");
  const [allserviceMetaDescription, setAllserviceMetaDescription] =
    useState("");
  const [allserviceMetaKeywords, setAllserviceMetaKeywords] = useState("");
  const [allservicePageTitle, setAllservicePageTitle] = useState("");
  const [allservicePageTitleDescription, setAllservicePageTitleDescription] =
    useState("");
  const [allservicePageDescription, setAllservicePageDescription] =
    useState("");

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const clearForm = () => {
    setName("");
    setEndpoint("");
    setOrderNo();
    setParent_id("");
    setStatus("");
    setFile(null);
    setImage_alt_text("");
    setMetaTitle("");
    setMetaDescription("");
    setMetaKeywords("");
    setPageDescription("");
    setPageTitle("");
    setPageTitleDescription("");
    setAllserviceMetaTitle("");
    setAllserviceMetaDescription("");
    setAllserviceMetaKeywords("");
    setAllservicePageTitle("");
    setAllservicePageTitleDescription("");
    setAllservicePageDescription("");
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    let formdata = new FormData();
    formdata.append("name", name.trim());
    formdata.append("order_no", orderNo);
    formdata.append("endpoint", endpoint);
    formdata.append("device_id", parent_id.trim());
    formdata.append("status", status);
    formdata.append("meta_title", metaTitle);
    formdata.append("meta_description", metaDescription);
    formdata.append("meta_keywords", metaKeywords);
    formdata.append("page_description", pageDescription);
    formdata.append("page_title", pageTitle);
    formdata.append("allservice_meta_title", allserviceMetaTitle);
    formdata.append("allservice_meta_description", allserviceMetaDescription);
    formdata.append("allservice_meta_keywords", allserviceMetaKeywords);
    formdata.append("allservice_page_title", allservicePageTitle);
    formdata.append(
      "allservice_page_title_description",
      allservicePageTitleDescription,
    );
    formdata.append("allservice_page_description", allservicePageDescription);
    formdata.append("image_alt_text", image_alt_text.trim());
    if (file) {
      formdata.append("image", file);
    }

    // let data = {
    //   name: name.trim(),

    //   device_id: parent_id?.length > 0 ? parent_id : null,
    //   status: status,
    // };

    let response = await handlePutData(
      `/api/v1/model/update/${id.trim()}`,
      formdata,
      true,
    );

    console.log("response", response);
    if (response?.status === 401) {
      logout();
      return;
    }
    if (response.status >= 200 && response.status < 300) {
      handleSnakbarOpen("Updated successfully", "success");

      clearForm();
      navigate("/model-list");
    } else {
      setLoading(false);
      handleSnakbarOpen(response?.data?.message, "error");
    }

    setLoading(false);
    // }
  };

  const customeTextFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    // padding: "15px 20px",

    // "& label.Mui-focused": {
    //   color: "#A0AAB4",
    // },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "15px 24px 15px 0px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const customeSelectFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",

    "& label.Mui-focused": {
      color: "#E5E5E5",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "10px 16px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "#",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const getDropdownList = async () => {
    setLoading2(true);

    let url = `/api/v1/device/leaf-dropdown`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setDeviceList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  const getData = async () => {
    setLoading3(true);

    let url = `/api/v1/model/${encodeURIComponent(id.trim())}`;
    let allData = await getDataWithToken(url);
    console.log("allData?.data?.data", allData?.data?.data);

    if (allData?.status === 401) {
      logout();
      return;
    }

    if (allData.status >= 200 && allData.status < 300) {
      setAllData(allData?.data?.data);
      setName(allData?.data?.data?.name || "");
      setOrderNo(allData?.data?.data?.order_no || "");
      setEndpoint(allData?.data?.data?.endpoint || "");
      setParent_id(
        allData?.data?.data?.device_id === null
          ? ""
          : allData?.data?.data?.device_id || "",
      );
      setStatus(allData?.data?.data?.status || "");
      setMetaTitle(allData?.data?.data?.meta_title || "");
      setMetaDescription(allData?.data?.data?.meta_description || "");
      setMetaKeywords(allData?.data?.data?.meta_keywords || "");
      setPageDescription(allData?.data?.data?.page_description || "");
      setPageTitle(allData?.data?.data?.page_title || "");
      setPageTitleDescription(
        allData?.data?.data?.page_title_description || "",
      );
      setAllserviceMetaTitle(allData?.data?.data?.allservice_meta_title || "");
      setAllserviceMetaDescription(
        allData?.data?.data?.allservice_meta_description || "",
      );
      setAllserviceMetaKeywords(
        allData?.data?.data?.allservice_meta_keywords || "",
      );
      setAllservicePageTitle(allData?.data?.data?.allservice_page_title || "");
      setAllservicePageTitleDescription(
        allData?.data?.data?.allservice_page_title_description || "",
      );
      setAllservicePageDescription(
        allData?.data?.data?.allservice_page_description || "",
      );
      setImage_alt_text(allData?.data?.data?.image_alt_text || "");

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading3(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading3(false);
  };

  useEffect(() => {
    if (id) {
      getData();
      getDropdownList();
    }
  }, [id]);
  return (
    <>
      <Grid container columnSpacing={3} style={{ padding: "24px 0" }}>
        <Grid size={6}>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{ color: "#0F1624", fontWeight: 600 }}
          >
            Update Model
          </Typography>
        </Grid>
        <Grid size={6} style={{ textAlign: "right" }}></Grid>
      </Grid>

      {Object.keys(allData || {}).length > 0 && (
        <div
          style={{
            background: "#fff",
            border: "1px solid #EAECF1",
            borderRadius: "12px",
            overflow: "hidden",
            padding: "16px",
            boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
          }}
        >
          <form onSubmit={onSubmit}>
            <Grid container spacing={2}>
              <Grid size={6}>
                <Typography
                  variant="medium"
                  color="text.main"
                  gutterBottom
                  sx={{ fontWeight: 500 }}
                >
                  Model Name *
                </Typography>
                <TextField
                  required
                  size="small"
                  fullWidth
                  id="name"
                  placeholder="Enter Model Name"
                  variant="outlined"
                  sx={{ ...customeTextFeild, mb: 2 }}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </Grid>
              <Grid size={6}>
                <Typography
                  variant="medium"
                  color="text.main"
                  gutterBottom
                  sx={{ fontWeight: 500 }}
                >
                  Order No *
                </Typography>
                <TextField
                  required
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  size="small"
                  fullWidth
                  id="order_no"
                  placeholder="Enter Order No"
                  variant="outlined"
                  sx={{ ...customeTextFeild, mb: 2 }}
                  value={orderNo}
                  onChange={(e) => {
                    setOrderNo(e.target.value);
                  }}
                />
              </Grid>
              <Grid size={6}>
                <Typography
                  variant="medium"
                  color="text.main"
                  gutterBottom
                  sx={{ fontWeight: 500 }}
                >
                  URL Endpoint *{" "}
                  <span style={{ color: "#898989" }}>
                    {" "}
                    (e.g: xxxx-xxxx-xxxx)
                  </span>
                </Typography>
                <TextField
                  required
                  size="small"
                  fullWidth
                  id="endpoint"
                  placeholder="Enter URL Endpoint"
                  variant="outlined"
                  sx={{ ...customeTextFeild, mb: 2 }}
                  value={endpoint}
                  onChange={(e) => {
                    setEndpoint(e.target.value);
                  }}
                />
              </Grid>
              <Grid size={6}>
                <Typography
                  variant="medium"
                  color="text.main"
                  gutterBottom
                  sx={{ fontWeight: 500 }}
                >
                  Select Device *
                </Typography>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    mb: 2,
                    ...customeSelectFeild,
                    "& label.Mui-focused": {
                      color: "rgba(0,0,0,0)",
                    },
                    "& .MuiOutlinedInput-input img": {
                      position: "relative",
                      top: "2px",
                    },
                  }}
                >
                  {parent_id?.length < 1 && (
                    <InputLabel
                      id="demo-simple-select-label"
                      sx={{ color: "#b3b3b3", fontWeight: 300 }}
                    >
                      Select Device
                    </InputLabel>
                  )}
                  <Select
                    labelId="demo-simple-select-label"
                    id="baseLanguage"
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 250,
                        },
                      },
                    }}
                    value={parent_id}
                    onChange={(e) => setParent_id(e.target.value)}
                  >
                    {deviceList?.map((item) => (
                      <MenuItem key={item} value={item?._id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={6}>
                <Typography
                  variant="medium"
                  color="text.main"
                  gutterBottom
                  sx={{ fontWeight: 500 }}
                >
                  Select Status
                </Typography>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    mb: 2,
                    ...customeSelectFeild,
                    "& label.Mui-focused": {
                      color: "rgba(0,0,0,0)",
                    },
                    "& .MuiOutlinedInput-input img": {
                      position: "relative",
                      top: "2px",
                    },
                  }}
                >
                  <Select
                    labelId="demo-simple-select-label-status"
                    id="status"
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 250,
                        },
                      },
                    }}
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <MenuItem value={true}>Active</MenuItem>
                    <MenuItem value={false}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={12}>
                <Typography
                  variant="medium"
                  color="text.main"
                  gutterBottom
                  sx={{ fontWeight: 500 }}
                >
                  Image Alt Text
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  id="image_alt_text"
                  placeholder="Image Alt Text"
                  variant="outlined"
                  sx={{ ...customeTextFeild, mb: 2 }}
                  value={image_alt_text}
                  onChange={(e) => {
                    setImage_alt_text(e.target.value);
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Typography
                  variant="medium"
                  color="text.main"
                  gutterBottom
                  sx={{ fontWeight: 500 }}
                >
                  Model Image
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <ImageUpload
                    file={file}
                    setFile={setFile}
                    dimension="Size: (200 : 200)"
                  />
                </Box>
              </Grid>
            </Grid>
            <Box>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ color: "#0F1624", fontWeight: 600, mb: 2 }}
              >
                Meta Information and Page Description
              </Typography>
              <MetaTagAndDescription
                metaTitle={metaTitle}
                setMetaTitle={setMetaTitle}
                metaDescription={metaDescription}
                setMetaDescription={setMetaDescription}
                metaKeywords={metaKeywords}
                setMetaKeywords={setMetaKeywords}
                pageDescription={pageDescription}
                setPageDescription={setPageDescription}
                pageTitle={pageTitle}
                setPageTitle={setPageTitle}
                pageTitleDescription={pageTitleDescription}
                setPageTitleDescription={setPageTitleDescription}
              />
            </Box>
            <Box sx={{ mt: 3 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ color: "#0F1624", fontWeight: 600, mb: 2 }}
              >
                All Service Website Page Meta Information and Page Description
              </Typography>
              <MetaTagAndDescription
                fieldIdPrefix="allservice_"
                metaTitle={allserviceMetaTitle}
                setMetaTitle={setAllserviceMetaTitle}
                metaDescription={allserviceMetaDescription}
                setMetaDescription={setAllserviceMetaDescription}
                metaKeywords={allserviceMetaKeywords}
                setMetaKeywords={setAllserviceMetaKeywords}
                pageDescription={allservicePageDescription}
                setPageDescription={setAllservicePageDescription}
                pageTitle={allservicePageTitle}
                setPageTitle={setAllservicePageTitle}
                pageTitleDescription={allservicePageTitleDescription}
                setPageTitleDescription={setAllservicePageTitleDescription}
              />
            </Box>
            <Box
              sx={{ p: 2, marginTop: "1px solid #EAECF0", textAlign: "right" }}
            >
              <Button
                variant="outlined"
                sx={{
                  mr: 2,
                  px: 2,
                  py: 1.25,
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#344054",
                  border: "1px solid #D0D5DD",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                }}
                component={Link}
                to="/model-list"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                disabled={loading}
                type="submit"
                sx={{
                  px: 2,
                  py: 1.25,
                  fontSize: "14px",
                  fontWeight: 600,
                  minWidth: "127px",
                  minHeight: "44px",
                }}
                disableElevation
              >
                <PulseLoader
                  color={"#4B46E5"}
                  loading={loading}
                  size={10}
                  speedMultiplier={0.5}
                />{" "}
                {loading === false && "Save changes"}
              </Button>
            </Box>
          </form>
        </div>
      )}
    </>
  );
};

export default UpdateModel;
